import { Customer } from 'Services/MongoRealm/Types';
import {
  PriceGroup,
  Product,
  ProductColumn,
  ProductColumnsIds,
  ProductDetailsTabsIds
} from '@setvi/shared/interfaces';
import { getProductColumns } from './helper';

export interface UseProductColumnsProps {
  selectedCustomer?: Customer;
  selectedPriceGroup?: PriceGroup;
  configColumns: ProductColumn[];
  productPricesLoading: boolean;
  searchQuery?: string;

  onPromotionClick?: (product: Product) => void;
  openProductDetails: (
    product: Product,
    defaultOpenedTab?: ProductDetailsTabsIds
  ) => void;
  onGetProductPrice: (product: Product[]) => Promise<void>;
}

export const useProductColums = ({
  selectedCustomer,
  productPricesLoading,
  searchQuery = '',
  configColumns,
  selectedPriceGroup,
  onGetProductPrice,
  openProductDetails,
  onPromotionClick
}: UseProductColumnsProps) => {
  const dependsOnCustomer = [
    ProductColumnsIds.GetPrice,
    ProductColumnsIds.GetCost,
    ProductColumnsIds.CustomerCost,
    ProductColumnsIds.Price,
    ProductColumnsIds.GP,
    ProductColumnsIds.Discount
  ];

  const columns = configColumns
    .map(column => ({
      ...column,
      visible: dependsOnCustomer.includes(column.id as ProductColumnsIds)
        ? !!selectedCustomer || !!selectedPriceGroup
        : true,
      cellContent: (product: Product) =>
        getProductColumns({
          id: column.id as ProductColumnsIds,
          product,
          selectedCustomer,
          selectedPriceGroup,
          productPricesLoading,
          searchQuery,
          onGetProductPrice,
          openProductDetails,
          onPromotionClick
        })
    }))
    .filter(column => column.visible);

  return { columns };
};
